// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.Playlists {
  height: 100%;
  margin-bottom: 0 !important;
}
.Playlists .full-height {
  height: 100%;
}
.Playlists .playlist-container {
  padding: 20px 30px;
}
.Playlists .playlist-content {
  height: calc(100% - 72px);
}
.Playlists .playlist-toolbar {
  display: flex;
  align-items: center;
  height: 64px;
}
.Playlists .playlist-toolbar .playlist-paginator {
  margin-right: 20px;
}
.Playlists .playlist-toolbar .toolbar-right {
  margin-left: auto;
}
.Playlists .playlist-toolbar .toolbar-right .toolbar-right-items {
  display: flex;
  align-items: center;
  justify-content: right;
}
.Playlists .playlist-toolbar .toolbar-right .toolbar-right-items .selected-count-container {
  display: flex;
  align-items: center;
  color: #00A474;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: normal;
}
.Playlists .playlist-toolbar .toolbar-right .toolbar-right-items .select-container {
  margin-left: 20px;
}
.Playlists .playlist-toolbar .toolbar-right .toolbar-right-items .all-current-future-container {
  display: flex;
  align-items: center;
  text-align: right;
  width: 240px;
  border-radius: 4px;
  background: #FFFFFF;
  border: solid 1px #E1E1E9;
  margin-left: 10px;
  padding: 15px 20px;
}
.Playlists .location-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #222732;
  color: #F6F6F6;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  font-weight: 300;
  overflow: hidden;
  transition: 0.5s ease-in-out height;
}
.Playlists .location-bar .bar-content {
  display: flex;
  align-items: center;
  padding: 0 40px;
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0;
  transition: 0.5s ease-in-out opacity;
}
.Playlists .location-bar .bar-content .selected-count {
  margin-left: 10px;
}
.Playlists .location-bar.show {
  height: 56px;
}
.Playlists .location-bar.show .bar-content {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/vibeguide/src/components/Playlists/Playlists.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACEA;EACE,YAAA;EACA,2BAAA;AAwFF;AAtFE;EACE,YAAA;AAwFJ;AArFE;EACE,kBAAA;AAuFJ;AAnFE;EACE,yBAAA;AAqFJ;AAlFE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAoFJ;AAlFI;EACE,kBAAA;AAoFN;AAjFI;EACE,iBAAA;AAmFN;AAjFM;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAmFR;AAjFQ;EACE,aAAA;EACA,mBAAA;EACA,cDtBA;ECuBA,yBAAA;EACA,eAAA;EACA,mBAAA;AAmFV;AAhFQ;EACE,iBAAA;AAkFV;AA/EQ;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBDjCF;ECkCE,yBAAA;EACA,iBAAA;EACA,kBAAA;AAiFV;AA3EE;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBDnEQ;ECoER,cD/DQ;ECgER,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,mCAAA;AA6EJ;AA3EI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;EACA,oCAAA;AA6EN;AA3EM;EACE,iBAAA;AA6ER;AAzEI;EACE,YAAA;AA2EN;AAzEM;EACE,UAAA;AA2ER","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxPurple16: rgba($boxPurple, 0.16);\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n  boxPurple16: $boxPurple16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '../../sass/color.scss' as color;\n\n.Playlists {\n  height: 100%;\n  margin-bottom: 0 !important;\n\n  .full-height {\n    height: 100%;\n  }\n\n  .playlist-container {\n    padding: 20px 30px;\n    // padding-top: 0;\n  }\n\n  .playlist-content {\n    height: calc(100% - 72px);\n  }\n\n  .playlist-toolbar {\n    display: flex;\n    align-items: center;\n    height: 64px;\n\n    .playlist-paginator {\n      margin-right: 20px;\n    }\n\n    .toolbar-right {\n      margin-left: auto;\n\n      .toolbar-right-items {\n        display: flex;\n        align-items: center;\n        justify-content: right;\n\n        .selected-count-container {\n          display: flex;\n          align-items: center;\n          color: color.$success;\n          text-transform: uppercase;\n          font-size: 12px;\n          font-weight: normal;\n        }\n\n        .select-container {\n          margin-left: 20px;\n        }\n\n        .all-current-future-container {\n          display: flex;\n          align-items: center;\n          text-align: right;\n          width: 240px;\n          border-radius: 4px;\n          background: color.$white;\n          border: solid 1px color.$whiteSmoke;\n          margin-left: 10px;\n          padding: 15px 20px;\n        }\n      }\n    }\n  }\n\n  .location-bar {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    background: color.$secondary;\n    color: color.$lightGray;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n    font-weight: 300;\n    overflow: hidden;\n    transition: 0.5s ease-in-out height;\n\n    .bar-content {\n      display: flex;\n      align-items: center;\n      padding: 0 40px;\n      font-size: 12px;\n      text-transform: uppercase;\n      opacity: 0;\n      transition: 0.5s ease-in-out opacity;\n\n      .selected-count {\n        margin-left: 10px;\n      }\n    }\n\n    &.show {\n      height: 56px;\n\n      .bar-content {\n        opacity: 1;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxPurple16 = `rgba(109, 109, 181, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
